import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import '../public/icon/iconfont.css';

import filter from './filter';
Vue.use(filter);

import directive from '@/directives';
Vue.use(directive);

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import dict from '@/dict/dict';
Vue.prototype.$dict = dict;

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;


// @ts-ignore
import VueAnimateNumber from 'vue-animate-number';
Vue.use(VueAnimateNumber)

Vue.config.productionTip = false;

const vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

(window as any).vue = vue;
